import { oc } from '@orpc/contract'
import { z } from 'zod'

export const sqliteEchoContract = oc
  .input(
    z.object({
      message: z.string().min(1),
    })
  )
  .output(
    z.object({
      id: z.number().int().nonnegative(),
      message: z.string(),
      createdAt: z.string(),
    })
  )
